
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { JsonLdReview } from '@components/config/SEO';
import AirportTransfers from '@pages/airport-transfers/Index';
import { NextSeo } from 'next-seo';

export default function Index() {
  return (
    <div>
      <NextSeo
        title="Airport Transfers To & From Birmingham Airport | 247 Radio Carz"
        description="Let us help make your travel experience smooth and comfortable with our reliable private airport transfers. We offer spacious cars to take you from any of Birmingham's in luxurious style."
        openGraph={{
          url: 'https://www.247radiocarz.co.uk/become_a_driver',
        }}
        canonical="https://www.247radiocarz.co.uk/birmingham-airport-transfers"
      />
      <JsonLdReview />
      <AirportTransfers />
    </div>
  );
}
